import styled from 'styled-components'

import { useTranslation } from 'i18n-web/i18next'
import Text from 'components/Atoms/Text'
import Tooltip from 'components/Atoms/Tooltip'

const Component = styled.div`
  position: relative;
  margin-top: 4px;
  margin-left: 64px;

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    margin-left: 100px;
  }
`

const TooltipText = styled(Text)`
  display: inline-flex;
  &:first-of-type {
    margin-top: -1px;
  }
  &:before {
    content: '•';
    margin-right: 5px;
    display: block;
  }
`

const PhoneNumberTooltip = () => {
  const { t } = useTranslation()

  return (
    <Component>
      <Tooltip title={t('payBySignage.phoneNumber.title')}>
        <TooltipText className="tiny semiBold">
          {t('payBySignage.phoneNumber.pros.sendReceiptToYourPhone')}
        </TooltipText>
        <TooltipText className="tiny semiBold">
          {t('payBySignage.phoneNumber.pros.preventFraud')}
        </TooltipText>
        <TooltipText className="tiny semiBold">
          {t('payBySignage.phoneNumber.pros.keepYourPassSafe')}
        </TooltipText>
      </Tooltip>
    </Component>
  )
}

export default PhoneNumberTooltip
